import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c(VIcon,{attrs:{"color":_vm.color}},[_vm._v("square")]),_vm._v(" "+_vm._s(_vm.color)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }